interface SolutionsPhrasesMobileProps {
 syllable1: string
 syllable2: string
 syllable3?: string
}

export function SolutionsPhrasesMobile({
 syllable1,
 syllable2,
 syllable3
}: SolutionsPhrasesMobileProps) {
 return (
  <div className="font-['rns-milesblack'] font-bold text-left text-lg text-[var(--text-main)]">
   {syllable1}
   {syllable2 && (
    <>
     <span className="text-[var(--primary-yellow)]">_</span>
     {syllable2}
    </>
   )}
   {syllable3 && (
    <>
     <span className="text-[var(--primary-yellow)]">_</span>
     {syllable3}
    </>
   )}
  </div>
 )
}
